import CotacaoValores from "./CotacaoValores";

export default CotacaoValores;
